import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const ContactInformationSubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./ContactInformationSubForm"))
);
